module.exports = __webpack_public_path__ + "media/images/auth/rectangles_l3-7c06545574c57bf7616f5b9e70369caa.png";